// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'reply-all-solid';

export const Component = () => (
  <path d='M3.363 11.772c0 .235.095.423.286.658l7.539 7.05c.19.093.334.14.381.14.287 0 .43-.188.43-.517v-4.23c2.433 0 4.533.47 6.394 1.364 1.765.893 3.53 2.538 5.2 5.028.048.141.191.235.43.235.334 0 .477-.188.477-.517-.477-8.459-4.628-12.69-12.5-12.69V4.018c0-.33-.144-.517-.43-.517a.543.543 0 0 0-.381.141l-7.54 7.426c-.19.282-.286.516-.286.705Zm-2.863 0c0-.47.143-.799.43-.987l7.395-7.143c.19-.094.287-.141.334-.141.334 0 .477.188.477.516a.423.423 0 0 1-.143.33l-7.396 7.049c-.095.187-.143.329-.143.375 0 .141.048.235.143.282l7.396 6.72a.423.423 0 0 1 .143.33c0 .329-.143.516-.477.516a.435.435 0 0 1-.334-.14L.93 12.757a1.34 1.34 0 0 1-.43-.987v.001Z' />
);

export const viewBox = '0 0 25 25';
